import {
  TrendingUp,
  Heart,
  Target,
  PenTool,
  UserCheck,
  Briefcase,
  SearchCheck,
  Filter,
  ClipboardCheck,
  Wallet,
  LineChart,
  Megaphone,
  Users,
  Sparkles,
  Layers,
  BarChart3,
  Camera,
  Clapperboard,
  Goal,
  Globe,
  MonitorSmartphone,
  MousePointerClick,
  Gauge,
  Bot,
  Workflow,
  Activity,
  LayoutDashboard,
} from "lucide-react";

// 10 EFORY solutions. Each has summary (grid) + carousel deep-dive content.
export const SOLUTIONS = [
  {
    id: "gestao-comercial",
    number: "01",
    icon: Briefcase,
    title: "Gestão Comercial",
    short: "Operação de vendas estruturada com metas, processos e treinamento.",
    subtitle: "Estruturamos a operação, definimos metas e treinamos sua equipe comercial.",
    features: [
      { icon: Filter, label: "Estruturação da operação de vendas" },
      { icon: Goal, label: "Definição de metas, indicadores e processos" },
      { icon: Users, label: "Treinamento e acompanhamento da equipe comercial" },
    ],
    result: "Time comercial forte e resultado consistente.",
  },
  {
    id: "vendas-crm",
    number: "02",
    icon: TrendingUp,
    title: "Vendas & CRM",
    short: "Processo comercial completo com CRM inteligente, automações e IA.",
    subtitle: "Estruturamos todo o seu processo comercial com um CRM inteligente que trabalha por você.",
    features: [
      { icon: Filter, label: "Estruturação completa do processo comercial" },
      { icon: Bot, label: "CRM inteligente com automações e IA integrada" },
      { icon: BarChart3, label: "Gestão de funil, indicadores e acompanhamento de vendas" },
    ],
    result: "Processo comercial previsível e organizado.",
    portfolio: "crm",
  },
  {
    id: "consultoria",
    number: "03",
    icon: UserCheck,
    title: "Consultoria Estratégica",
    short: "Diagnóstico completo, plano de ação e acompanhamento estratégico.",
    subtitle: "Um diagnóstico completo do seu negócio com plano de ação e acompanhamento na execução.",
    features: [
      { icon: SearchCheck, label: "Diagnóstico completo do negócio" },
      { icon: ClipboardCheck, label: "Plano de ação com metas e prioridades" },
      { icon: UserCheck, label: "Acompanhamento estratégico para execução" },
    ],
    result: "Clareza e direção para escalar com segurança.",
  },
  {
    id: "gestao-financeira",
    number: "04",
    icon: Wallet,
    title: "Gestão Financeira",
    short: "Fluxo de caixa, custos e indicadores para decisões seguras.",
    subtitle: "Organizamos o seu financeiro para você crescer de forma sustentável e decidir com base em dados.",
    features: [
      { icon: Wallet, label: "Controle de fluxo de caixa e custos" },
      { icon: LineChart, label: "Indicadores financeiros para tomada de decisão" },
      { icon: TrendingUp, label: "Organização financeira para crescimento sustentável" },
    ],
    result: "Mais previsibilidade, controle e lucro.",
  },
  {
    id: "sistema-financeiro",
    number: "05",
    icon: LayoutDashboard,
    title: "Sistema de Gestão Financeira",
    short: "Controle financeiro completo e em tempo real, em um só lugar.",
    subtitle: "Controle financeiro simples e completo, com indicadores e relatórios em tempo real.",
    features: [
      { icon: Activity, label: "Controle financeiro simples, completo e em tempo real" },
      { icon: Wallet, label: "Gestão de contas, fluxo de caixa e indicadores em um só lugar" },
      { icon: BarChart3, label: "Relatórios inteligentes para decisões mais rápidas e seguras" },
    ],
    result: "Seu financeiro completo, em tempo real.",
    portfolio: "financeiro",
  },
  {
    id: "sites-landing-pages",
    number: "06",
    icon: Globe,
    title: "Sites & Landing Pages",
    short: "Sites rápidos e landing pages de alta conversão, integrados ao seu CRM.",
    subtitle: "Sites rápidos, modernos e responsivos, com landing pages desenvolvidas para conversão.",
    features: [
      { icon: MonitorSmartphone, label: "Sites rápidos, modernos e responsivos" },
      { icon: MousePointerClick, label: "Landing pages desenvolvidas para conversão" },
      { icon: Workflow, label: "Integração com CRM, WhatsApp e automações" },
    ],
    result: "Presença digital que gera leads e vendas.",
    portfolio: "sites",
  },
  {
    id: "marketing-digital",
    number: "07",
    icon: Heart,
    title: "Marketing Digital",
    short: "Gestão de redes sociais, conteúdo estratégico e posicionamento para fortalecer sua marca.",
    subtitle: "Gestão profissional de redes sociais, posicionamento e conteúdo estratégico para construir autoridade e relacionamento com quem compra.",
    features: [
      { icon: Users, label: "Gestão de redes sociais (Instagram, Facebook, LinkedIn, TikTok)" },
      { icon: Layers, label: "Planejamento estratégico de conteúdo" },
      { icon: Sparkles, label: "Posicionamento para fortalecer sua marca" },
    ],
    result: "Marca forte, com autoridade e relacionamento.",
  },
  {
    id: "trafego-pago",
    number: "08",
    icon: Target,
    title: "Tráfego Pago",
    short: "Campanhas em Meta e Google Ads focadas em leads e vendas.",
    subtitle: "Campanhas em Meta Ads e Google Ads com otimização contínua para maximizar o retorno.",
    features: [
      { icon: Goal, label: "Campanhas para geração de leads e vendas" },
      { icon: LineChart, label: "Otimização contínua para maior retorno sobre investimento" },
      { icon: Target, label: "Estratégias para Meta Ads e Google Ads" },
    ],
    result: "Mais leads qualificados com menor custo.",
  },
  {
    id: "criativos",
    number: "09",
    icon: PenTool,
    title: "Criativos de Alta Conversão",
    short: "Anúncios, artes e vídeos desenvolvidos para alta conversão.",
    subtitle: "Criativos pensados para captar atenção rapidamente e converter mais.",
    features: [
      { icon: Sparkles, label: "Anúncios desenvolvidos para alta conversão" },
      { icon: Clapperboard, label: "Artes e vídeos que captam atenção rapidamente" },
      { icon: Gauge, label: "Testes constantes para aumentar performance" },
    ],
    result: "Anúncios que chamam atenção e convertem.",
  },
  {
    id: "conteudo",
    number: "10",
    icon: Camera,
    title: "Produção de Conteúdo",
    short: "Roteiros, captação e edição profissional para gerar autoridade.",
    subtitle: "Do roteiro à edição, produzimos conteúdo pensado para gerar autoridade e vendas.",
    features: [
      { icon: PenTool, label: "Roteiros estratégicos para Reels e vídeos" },
      { icon: Camera, label: "Captação e edição profissional de conteúdo" },
      { icon: Megaphone, label: "Conteúdo pensado para gerar autoridade e vendas" },
    ],
    result: "Conteúdo que gera conexão e vendas.",
  },
];

const ASSETS_BASE =
  "https://static.prod-images.emergentagent.com/jobs/9e70c3a0-45b9-4ff4-866e-a06ff971a4d7/images/";

// Portfolio modal configs per solution type.
export const PORTFOLIOS = {
  sites: {
    triggerLabel: "Ver portfólio",
    title: "Sites & landing pages que",
    titleHighlight: "já criamos",
    description: "Alguns exemplos de projetos desenvolvidos pela EFORY para diferentes segmentos.",
    items: [
      {
        id: "fitness",
        title: "Studio de Performance",
        category: "Academia & Fitness",
        image: ASSETS_BASE + "81d64ae4f0a821a1eba85f2b36c309d153ed43bffa670c10ab6ac0f8b2c73f15.png",
      },
      {
        id: "restaurant",
        title: "Restaurante Gourmet",
        category: "Gastronomia",
        image: ASSETS_BASE + "d296cad809b68eb4d89d49705a813699c22a805408bd91d2f703d4980c419b11.png",
      },
      {
        id: "clinic",
        title: "Clínica & Saúde",
        category: "Saúde & Bem-estar",
        image: ASSETS_BASE + "b835da2a2d56fc93e84e31bebd4a15904189aff68b240efcdf7c69fb0ed52091.png",
      },
      {
        id: "realestate",
        title: "Imobiliária Premium",
        category: "Imóveis",
        image: ASSETS_BASE + "c4f18be745e07066dfa0599c14b0710cd28f4f87567baeafadfc9635cd44a705.png",
      },
      {
        id: "ecommerce",
        title: "Loja de Moda",
        category: "E-commerce",
        image: ASSETS_BASE + "2d5b0a6221066bbf1078ba59425b88aa5d2ef2993835685fd59d64cc9f6f7621.png",
      },
      {
        id: "saas",
        title: "Plataforma SaaS",
        category: "Tecnologia",
        image: ASSETS_BASE + "1fa077ec20dcfc6fe7b672220d02dd30e78d53bea71e7bf00e9c845cf2319c95.png",
      },
    ],
    features: null,
    footerText: "Vamos criar o site do seu negócio.",
    ctaLabel: "Quero um site assim",
    ctaMessage:
      "Olá! Vi o portfólio de sites da EFORY e quero um site/landing page assim para o meu negócio.",
  },
  crm: {
    triggerLabel: "Conhecer o sistema",
    title: "Sistema Próprio de",
    titleHighlight: "CRM",
    description:
      "Tecnologia desenvolvida para organizar, automatizar e acelerar seu processo comercial.",
    items: [
      {
        id: "crm-funil",
        title: "Funil de vendas personalizado",
        category: "Pipeline comercial",
        image: "https://customer-assets-4nw71qhi.emergentagent.net/job_plataforma-consultor/artifacts/h62zdsw8_papiline%20crm.jpeg",
      },
      {
        id: "crm-atendimento",
        title: "WhatsApp, Instagram e IA integrados",
        category: "Atendimento centralizado",
        image: "https://customer-assets-4nw71qhi.emergentagent.net/job_plataforma-consultor/artifacts/5rb2nqz9_crm%201.jpeg",
      },
      {
        id: "crm-indicadores",
        title: "Indicadores, metas e relatórios",
        category: "Gestão comercial",
        image: "https://customer-assets-4nw71qhi.emergentagent.net/job_plataforma-consultor/artifacts/as9ehxff_crm%20dashoard.jpeg",
      },
    ],
    features: [
      "Parceiro Oficial Meta",
      "Integração com WhatsApp e Instagram",
      "Inteligência Artificial (IA)",
      "Funil de vendas personalizado",
      "Automação de processos",
      "Follow-up automático",
      "Gestão completa de leads",
      "Histórico de atendimento",
      "Agenda integrada",
      "Gestão de tarefas",
      "Múltiplos usuários",
      "Indicadores e relatórios",
      "Pipeline comercial",
      "Controle de metas",
      "Centralização do relacionamento com clientes",
    ],
    footerText: "Vamos acelerar o seu processo comercial.",
    ctaLabel: "Quero conhecer o CRM",
    ctaMessage: "Olá! Quero conhecer o Sistema Próprio de CRM da EFORY para o meu negócio.",
  },
  financeiro: {
    triggerLabel: "Conhecer o sistema",
    title: "Sistema Próprio de",
    titleHighlight: "Gestão Financeira",
    description:
      "Controle financeiro completo para empresas que desejam crescer com organização.",
    items: [
      {
        id: "fin-dashboard",
        title: "Dashboard em tempo real",
        category: "Visão geral",
        image: "https://customer-assets-4nw71qhi.emergentagent.net/job_plataforma-consultor/artifacts/3au22fif_gest%C3%A7ao%20financedira%201.jpeg",
      },
      {
        id: "fin-contas",
        title: "Contas bancárias e saldo consolidado",
        category: "Controle financeiro",
        image: "https://customer-assets-4nw71qhi.emergentagent.net/job_plataforma-consultor/artifacts/dz3fqavj_gesta%C3%A3o%20financeira%202.jpeg",
      },
      {
        id: "fin-movimentacoes",
        title: "Histórico de movimentações",
        category: "Contas a pagar e receber",
        image: "https://customer-assets-4nw71qhi.emergentagent.net/job_plataforma-consultor/artifacts/s0oevlj5_gest%C3%A3o%20financeira%203.jpeg",
      },
      {
        id: "fin-relatorios",
        title: "Relatórios, DRE e indicadores",
        category: "Análise financeira detalhada",
        image: "https://customer-assets-4nw71qhi.emergentagent.net/job_plataforma-consultor/artifacts/5nbz78mj_gest%C3%A3o%20financeira%204.jpeg",
      },
    ],
    features: [
      "Contas a pagar e receber",
      "Fluxo de caixa",
      "Saldo bancário",
      "Projeção de saldo",
      "Planejamento financeiro",
      "Metas financeiras",
      "Cadastro de clientes",
      "Cadastro de fornecedores",
      "Cadastro de produtos e serviços",
      "Controle de receitas e despesas",
      "Relatórios gerenciais",
      "Exportação de dados",
      "Múltiplos usuários",
      "Indicadores financeiros",
      "Dashboard em tempo real",
    ],
    footerText: "Vamos organizar o financeiro da sua empresa.",
    ctaLabel: "Quero conhecer o sistema",
    ctaMessage:
      "Olá! Quero conhecer o Sistema Próprio de Gestão Financeira da EFORY para o meu negócio.",
  },
};

// Numbers / recurring revenue. Animated counters.
export const STATS = [
  { to: 7, suffix: "+", label: "Anos de experiência" },
  { to: 250, suffix: "+", label: "Empresas atendidas" },
  { to: 1300, suffix: "+", label: "Projetos e estratégias desenvolvidos" },
  { prefix: "R$ ", to: 5.5, decimals: 1, suffix: " mi", label: "Em receita gerada" },
];

export const RECURRING_PLANS = [
  {
    name: "Sistema próprio de CRM",
    desc: "Gestão de leads, funil e relacionamento com o cliente em um só lugar.",
    highlight: false,
    color: "blue",
    features: ["Funil de vendas", "Histórico do cliente", "Acompanhamento de metas"],
  },
  {
    name: "Sistema próprio de Gestão Financeira",
    desc: "Contas a pagar e a receber, fluxo de caixa e indicadores que geram decisão.",
    highlight: true,
    color: "green",
    features: ["Fluxo de caixa", "Indicadores e relatórios", "Projeção de saldo"],
  },
];
